/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { AfterViewInit, Component, ElementRef, inject } from "@angular/core";

@Component({
	selector: "globalictcc-terms-of-use",
	standalone: true,
	templateUrl: "./terms-of-use.component.html",
	styleUrl: "./terms-of-use.component.scss"
})
export class TermsOfUseComponent implements AfterViewInit {
	private _elementRef = inject(ElementRef<HTMLElement>);

	ngAfterViewInit(): void {
		requestAnimationFrame(() => {
			const scrollContainer = this._elementRef.nativeElement.closest("section");

			scrollContainer?.scrollTo({
				top: 0,
				left: 0,
				behavior: "auto"
			});
		});
	}
}
